import React from "react";
import ReactDOM from "react-dom";
import { connect } from "react-redux";
import { Button } from "devextreme-react";
import moment from "moment";


import DataGrid, { Column, Paging, Pager, RemoteOperations, Export, Sorting } from "devextreme-react/ui/data-grid";
import LoadingGif from "../../../../../images/animacion2[18].gif";
import HeaderTooltip from "../../../../Shared/headerTooltip";

import { setShowHideForm, doGetDraftById, setStep, setDataNewComplain, setDenunciasFiltradaEmpresa, doGetdenunciaPDF, setDenunciasFilter, doGetComplains, setCleanDataComplain, doAutoCompleteTrabajadorInfo, setIdComplaint, setSortDenunciasByFechaDenuncia } from "./actions";

import { formatDateForFilter } from "../../../../../helpers/dateFormat";
import { filterType, filterData } from "../../../../../helpers/filterHelper";
import TableFilter from "../../../../Shared/tableFilter";

import ModalDraft from "./modalDraft";
import UserInfoColumn from "../../../../Shared/UserInfoColumn";

import SiniestroInfoColumn from "../../../../Shared/SiniestroInfoColumn";
import validaciones from "../../../../../helpers/validaciones";
import ModalDocumentos from "../../../Documentos/modalDocumentos";


class TableDenuncias extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      filtersLoaded: false,
      doFilterFechaDenuncia: false,
      FechaDenuncia: null,
      mainFilterSelected: null,
    };
    this.tableRef = React.createRef();
  }

  componentDidMount = () => {
    if (!this.state.filtersLoaded || (this.props.listaDenuncias != null && !this.props.listaDenuncias.length)) {
      // From: 1 año hacia atras
      // to: año actual.
      const data = {
        from: formatDateForFilter(moment().subtract(1, "year")),
        to: formatDateForFilter(moment()),
      };
      this.props.dispatch(doGetComplains(data, true));
      this.setState({ filtersLoaded: true });
    }
  }

  shouldComponentUpdate = (nextProps) => {
    if (this.props.jsonData !== nextProps.jsonData || this.props.showHideForm !== nextProps.showHideForm) return false;
    return true;
  }

  componentDidUpdate = (prevProps) => {
    if (prevProps.sucursalId !== this.props.sucursalId) {
      // From: 1 año hacia atras
      // to: año actual.
      const data = {
        from: formatDateForFilter(moment().subtract(1, "year")),
        to: formatDateForFilter(moment()),
      };
      this.props.dispatch(doGetComplains(data, true));
    }
  }

  componentWillUnmount = () => {
    if (this.props.showHideForm) {
      this.props.dispatch(setShowHideForm(false));
      this.props.dispatch(setCleanDataComplain());
    }
  }

  onExporting = (e) => {
    e.component.beginUpdate();
    e.component.columnOption("RutTrabajador", "visible", true);
    e.component.columnOption("IdSiniestro", "visible", true);
  }
  onExported = (e) => {
    e.component.columnOption("RutTrabajador", "visible", false);
    e.component.columnOption("IdSiniestro", "visible", false);
    e.component.endUpdate();
  }

  getDraftComplain = (row) => {
    this.props.dispatch(doGetDraftById(row.data));
  }

  getButton = (element, row) => {
    switch (row.data.EstadoDenuncia) {
      case "Pendiente":

        if (row.data.TieneBorrador) {
          ReactDOM.render(<Button
            text="Borrador"
            type="default"
            className="slimButton"
            onClick={() => this.getDraftComplain(row)}
          />, element);
        } else {
          ReactDOM.render(<Button
            text="Enviar"
            type="success"
            className="slimButton"
            onClick={() => this.handleSend(row.data)}
          />, element);
        }

        break;
      case "Enviada":
        if (row.data.TieneBorrador) {
          ReactDOM.render(<Button
            text="Borrador"
            type="default"
            className="slimButton"
            onClick={() => this.getDraftComplain(row)}
          />, element);
        } else {
          ReactDOM.render(<Button
            text="Reenviar"
            type="success"
            className="slimButton"
            onClick={() => this.handleSend(row.data)}
          />, element);
        }

        break;
      default:
        break;
    }
  }

  handleSend = (data) => {
    const newJsonData = { ...this.props.jsonData };
    newJsonData.formInfoDenuncia.rutTxt = data.RutTrabajador;
    newJsonData.formInfoDenuncia.FechaPresentacion = data.FechaSiniestroOrPresentacion;
    newJsonData.IdSiniestro = data.IdSiniestro;
    this.props.dispatch(setIdComplaint(data.IdSiniestro));
    const existList = this.props.listaTipoDenuncias && Array.isArray(this.props.listaTipoDenuncias);
    if (data.TipoDenuncia == null || !existList) {
      this.props.dispatch(setDataNewComplain(newJsonData));
      this.props.dispatch(setStep(1));
      this.props.dispatch(setShowHideForm(true));
    } else {
      newJsonData.formInfoDenuncia.tipoDenuncia = this.props.listaTipoDenuncias.find((x) => x.DescripcionTipoDenuncia === data.TipoDenuncia);
      this.props.dispatch(doAutoCompleteTrabajadorInfo(newJsonData, this.props.companyId))
    }
  }

  handleNewDenuncia = (data) => {
    this.props.dispatch(setStep(1));
    this.props.dispatch(setShowHideForm(true));
  }

  handleFilterChange = (text, filters) => {
    const currentFilters = [...filters];
    const filtrosDenuncias = [...this.props.filtrosDenuncias];
    const filtroTipoSiniestro = this.props.filtroTipoSiniestro[0];
    if ((currentFilters && currentFilters[0] && currentFilters[0].value.value === "Enviada") || (currentFilters && currentFilters.length === 0)) {
      const isPresentFiltroTipoSiniestro = filtrosDenuncias.find((x) => x.column === "TipoSiniestro");
      if (!isPresentFiltroTipoSiniestro) {
        filtrosDenuncias.push(filtroTipoSiniestro);
        this.props.dispatch(setDenunciasFilter(filtrosDenuncias));
      }
      if (currentFilters && currentFilters.length === 0) {
        this.props.dispatch(setSortDenunciasByFechaDenuncia(false));
      } else {
        this.props.dispatch(setSortDenunciasByFechaDenuncia(true));
      }
    } else if (currentFilters && currentFilters[0] && currentFilters[0].value.value === "Pendiente") {
      const filtrosDefault = filtrosDenuncias.filter((x) => x.column !== "TipoSiniestro");
      this.props.dispatch(setDenunciasFilter(filtrosDefault));
      this.props.dispatch(setSortDenunciasByFechaDenuncia(false));
    }

    if (text) {
      currentFilters.push({
        column: "RutTrabajador", filterValue: null, value: { text, value: text }, type: filterType.search,
      });
      currentFilters.push({
        column: "IdSiniestro", filterValue: null, value: { text, value: text }, type: filterType.search,
      });
      currentFilters.push({
        column: "NombreTrabajador", filterValue: null, value: { text, value: text }, type: filterType.search,
      });
      currentFilters.push({
        column: "Folio", filterValue: null, value: { text, value: text }, type: filterType.search,
      });
    }
    const FechaDenuncia = currentFilters.length > 0 ? currentFilters.filter((f) => f.column === "FechaSiniestroOrPresentacion") : [];
    if (FechaDenuncia.length > 0) {
      const pivotFecha = FechaDenuncia.find((i) => i.column === "FechaSiniestroOrPresentacion");
      let FechaDesde = null;

      if (this.state.doFilterFechaDenuncia === true) {
        FechaDesde = this.state.FechaDenuncia;
      } else {
        FechaDesde = formatDateForFilter(moment().subtract(1, "year"));
      }
      const dateIsBefore = moment(pivotFecha.value.value.from).isBefore(moment(FechaDesde));
      // llamado al api cuando las fechas son menores con respecto a las que mando por primera vez
      if (dateIsBefore === true) {
        const data = {
          from: formatDateForFilter(moment(pivotFecha.value.value.from)),
          to: formatDateForFilter(moment(pivotFecha.value.value.to)),
        };
        this.props.dispatch(doGetComplains(data, false));
        this.setState({
          doFilterFechaDenuncia: true,
          FechaDenuncia: pivotFecha.value.value.from,
        });
      }
    }
    if (this.state.doFilterFechaDenuncia && FechaDenuncia.length === 0) {
      // vuelvo a la carga de datos inicial. al limpiar el rango de fecha que fue menor a la orginal
      const data = {
        from: formatDateForFilter(moment().subtract(1, "year")),
        to: formatDateForFilter(moment()),
      };
      this.props.dispatch(doGetComplains(data, true));
      this.setState({
        doFilterFechaDenuncia: false,
        FechaDenuncia: null,
      });
    }


    let newData = null;
    if (currentFilters.length > 0) {
      newData = filterData(this.props.listaDenuncias, currentFilters);
    } else if (this.state.mainFilterSelected !== "TODAS") {
      const currentFiltersDefault = [
        {
          column: "EstadoDenuncia", value: { text: "Pendiente", value: "Pendiente" },
        },
      ];
      newData = filterData(this.props.listaDenuncias, currentFiltersDefault);
    } else {
      newData = this.props.listaDenuncias;
    }
    this.props.dispatch(setDenunciasFiltradaEmpresa(newData));
  }

  optionMainFilterSelected = (option) => {
    this.setState({ mainFilterSelected: option });
  }

  handleDctos = (link) => {
    window.open(link, "_blank");
  }

  handleViewDocuments = (row) => {
    this.props.dispatch(doGetdenunciaPDF(row.data.IdSiniestro, row.data.idDocumento));
  }

  pivotDownloadExcel = () => {
    this.tableRef.exportToExcel(false);
  }
  downloadExcel = (options) => {
    if (options.gridCell.rowType === "data") {
      options.horizontalAlignment = "left";
    }
  }


  render() {
    const { filtrosDenuncias } = this.props;

    return (
      <React.Fragment>
        <ModalDocumentos />
        <div className="table-wrapper">
          <ModalDraft />
          <TableFilter
            placeholder="Buscar siniestro por trabajador, ID o folio"
            onChange={this.handleFilterChange}
            filters={filtrosDenuncias}
            show={this.props.listaDenuncias != null}
            buttons={
              {
                filter: { buttonName: "iconFilter", visible: true, buttonAction: null },
                document: { buttonName: "iconDocument", visible: false, buttonAction: null },
                download: { buttonName: "iconDownload", visible: true, buttonAction: this.pivotDownloadExcel },
                newItem: {
                  buttonName: "custom", visible: true, buttonAction: () => this.handleNewDenuncia(null), buttonText: "Vieja denuncia",
                },
              }
            }
            selectedMainFilter={this.props.selectedTipoDenuncia}
            mainFilter={this.props.mainFilters}
            optionMainFilterSelected={(option) => this.optionMainFilterSelected(option)}
          />
          <DataGrid
            dataSource={this.props.listaDenunciasFiltrada}
            showBorders={false}
            showColumnLines={false}
            showRowLines={false}
            noDataText=""
            ref={(ref) => { if (ref !== null) this.tableRef = ref.instance; }}
            className="custom-table denuncias"
            rowAlternationEnabled
            hoverStateEnabled
            loadPanel={{
              enabled: true,
              showPane: true,
              showIndicator: true,
              indicatorSrc: LoadingGif,
              text: "Cargando...",
            }}
            onContentReady={(e) => {
              if (e.component.totalCount() === 0 || this.props.totalDenuncias === 0) {
                const config = {};
                config.addClass = "table-margin";
                const noDataSpan = e.component.element().querySelector(".dx-datagrid-nodata");
                const element = validaciones.noDataDOMElement(config, "Sin denuncias");
                noDataSpan.appendChild(element);
              }
            }}
            selection={{
              mode: "single",
            }}
            onExporting={this.onExporting}
            onExported={this.onExported}
          >

            <Sorting mode="single" />

            <Column
              allowSearch
              caption="Trabajador"
              calculateCellValue={(rowData) => `${rowData.NombreTrabajador}`}
              dataField={["NombreTrabajador", "RutTrabajador"]}
              cellTemplate={(element, row) => (
                <React.Fragment >
                  {
                    ReactDOM.render(<UserInfoColumn
                      nombre={row.data.NombreTrabajador}
                      rut={row.data.RutTrabajador}
                    />, element)
                  }

                </React.Fragment>
              )}


            />
            <Column
              caption="Rut"
              dataField="RutTrabajador"
              visible={false}
            />
            <Column
              caption="Siniestro"
              calculateCellValue={(rowData) => `${rowData.TipoSiniestro}`}
              cellTemplate={(element, row) => (
                <React.Fragment >
                  {
                    ReactDOM.render(<SiniestroInfoColumn
                      active={row.data.Reposo}
                      title={row.data.TipoSiniestro}
                      subtitle={(row.data.IdSiniestro != null || row.data.IdSiniestro !== "") ? Number(row.data.IdSiniestro).toString() : row.data.Folio}
                    />, element)
                  }

                </React.Fragment>
              )}

            />
            <Column
              caption="Id Siniestro"
              dataField="IdSiniestro"
              visible={false}
            />

            <Column
              dataField="FechaSiniestroOrPresentacion"
              caption="Fecha Siniestro"
              dataType="date"
              format="dd/MM/yyyy"
              defaultSortIndex={this.props.sortDenunciasByFechaDenuncia ? undefined : 0}
              defaultSortOrder="asc"
              sortingMethod={(v1, v2) => {
                if (!v1) return 1;
                if (!v2) return -1;
                const v1d = moment(v1, "DD/MM/YYYY");
                const v2d = moment(v2, "DD/MM/YYYY");
                if (v1d.isAfter(v2d)) return -1;
                if (v1d.isSame(v2d)) return 0;
                if (v1d.isBefore(v2d)) return 1;
                return 0;
              }}
            />

            <Column
              dataField="FechaDenuncia"
              caption="Fecha Denuncia"
              dataType="date"
              format="dd/MM/yyyy"
              defaultSortIndex={this.props.sortDenunciasByFechaDenuncia ? 0 : undefined}
              defaultSortOrder="asc"
              sortingMethod={(v1, v2) => {
                if (!v1) return 1;
                if (!v2) return -1;
                const v1d = moment(v1, "DD/MM/YYYY");
                const v2d = moment(v2, "DD/MM/YYYY");
                if (v1d.isAfter(v2d)) return -1;
                if (v1d.isSame(v2d)) return 0;
                if (v1d.isBefore(v2d)) return 1;
                return 0;
              }}
            />

            <Column
              dataField="TipoDenuncia"
              caption="Denuncia"
              cellTemplate={(element, props) => (
                <React.Fragment >
                  {
                    ReactDOM.render(
                      <div className="group-Column-Prestaciones">
                        <div className={(`${props.data.TipoDenuncia}`.indexOf("DIAT") !== -1) ? "table-label-light-blue" : "table-label-gray"}>
                          {props.data.TipoDenuncia}
                        </div>
                        {/* <div className="text spaceText" >{props.data.Folio}</div> */}
                      </div>
                      , element
                    )
                  }

                </React.Fragment>
              )}

              headerCellComponent={(props) => (
                <HeaderTooltip
                  id="tooltipDenuncias"
                  headerText="Tipo Denuncia"
                  toolTipText="DIAT: Denuncia Individual de accidente del trabajador."
                  toolTipText2="DIEP: Denuncia Individual de enfermedad profesional."
                  widthprops={360}
                />
              )}
            />

            <Column
              dataField="EstadoDenuncia"
              caption="Estado"
              calculateCellValue={(rowData) => `${rowData.EstadoDenuncia}`}
              cellTemplate={(element, props) => (
                <React.Fragment >
                  {
                    ReactDOM.render(<span className={`estado-${props.data.EstadoDenuncia}`}>{props.data.EstadoDenuncia}</span>, element)
                  }

                </React.Fragment>
              )}
            />
            <Column
              caption=""
              alignment="right"
              cellTemplate={(element, props) => (
                <React.Fragment>
                  {
                    ReactDOM.render(props.data.EstadoDenuncia !== "Pendiente" && <Button
                      text="Ver"
                      type="success"
                      className="slimButton"
                      onClick={() => this.handleViewDocuments(props)}
                    />, element)
                  }
                </React.Fragment>
              )}
            />
            <Column
              caption=""
              cellTemplate={(element, row) => (
                <React.Fragment >
                  {
                    this.getButton(element, row)
                  }
                </React.Fragment>
              )}
            />
            <RemoteOperations
              paging={false}
              filtering
              summary={false}
              groupPaging={false}
              grouping={false}
              sorting={false}
            />
            <Paging
              defaultPageSize={20}
            />
            <Pager
              visible
              showInfo
              infoText={(page, total, items) => `Página ${page} de ${total} (${items} resultados)`}
            />
            <Export visible={false} enabled customizeExcelCell={this.downloadExcel} allowExportSelectedData={false} texts fileName="DenunciasEmpresa" />
          </DataGrid>
        </div>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  listaDenuncias: state.denuncias.listaDenuncias,
  listaDenunciasFiltrada: state.denuncias.listaDenunciasFiltrada,
  filtrosDenuncias: state.denuncias.filtrosDenuncias,
  selectedTipoDenuncia: state.denuncias.selectedTipoDenuncia,
  totalDenuncias: state.denuncias.totalDenuncias,
  shouldUpdateDataGrid: state.denuncias.shouldUpdateDataGrid,
  companyId: state.global.companyId,
  sucursalId: state.global.sucursalId,
  userData: state.global.userData,
  listaTipoDenuncias: state.global.listaTipoDenuncias,
  jsonData: state.denuncias.jsonData,
  isDownloadLoading: state.denuncias.isDownloadLoading,
  mainFilters: state.denuncias.mainFilters,
  filtroTipoSiniestro: state.denuncias.filtroTipoSiniestro,
  showHideForm: state.denuncias.showHideForm,
  sortDenunciasByFechaDenuncia: state.denuncias.sortDenunciasByFechaDenuncia,
});

const mapDispatchToProps = (dispatch) => ({
  dispatch: (action) => { dispatch(action); },
});

export default connect(mapStateToProps, mapDispatchToProps)(TableDenuncias);
